import type { ImageParams } from 'components/Common/ResponsiveImage'
import NestableClickable from 'components/Common/NestableClickable'
import type { ImageCarouselRefInterface } from 'LuxKit/Carousel/BaseImageCarousel'
import ImageCarousel from 'LuxKit/Carousel/ImageCarousel'
import { useCallback, useRef } from 'react'
import styled from 'styled-components'
import { MOBILE_OFFER_PAGE_GALLERY_ASPECT_RATIO } from './TripPlanDetailDrawer.styles'

const CAROUSEL_IMAGE_PARAMS: ImageParams = {
  mobileAspectRatio: '16:9',
  tabletAspectRatio: '16:9',
  quality: 'good',
  fit: 'center',
}

const DrawerDetailMobileCarouselContainer = styled(NestableClickable)`
  position: relative;
  width: 100%;
  aspect-ratio: ${MOBILE_OFFER_PAGE_GALLERY_ASPECT_RATIO};
  overflow: hidden;
`

interface Props {
  images: Array<App.Image>
  onOpenLightbox: (index: number) => void
}

function DrawerDetailMobileImageCarousel({ images, onOpenLightbox }: Props) {
  const carouselRef = useRef<ImageCarouselRefInterface>(null)

  const handleCarouselClick = useCallback(() => {
    const index = carouselRef.current?.getCurrentImageIndex() ?? 0
    onOpenLightbox(index)
  }, [onOpenLightbox])

  return (
    <DrawerDetailMobileCarouselContainer
      onClick={handleCarouselClick}
      data-testid="drawer-detail-mobile-carousel"
    >
      <ImageCarousel
        carouselRef={carouselRef}
        images={images}
        imageParams={CAROUSEL_IMAGE_PARAMS}
        eagerLoadFirstImage
        arrowBehaviour="always-visible"
      />
    </DrawerDetailMobileCarouselContainer>
  )
}

export default DrawerDetailMobileImageCarousel
